export enum TextMapper {
    ORDER = "order",
    ACTS = "acts",
    PRICE = "price",
    TIMETABLE = "timetable",
}
export enum DocTagIdsMapper {
    ORDER = 22,
    ACTS = 23,
    PRICE = 24,
    TIMETABLE = 25,
}

export const docTagIdsObject = Object.values(DocTagIdsMapper).reduce((acc: Record<number, boolean>, val) => {
    acc[val as number] = true;
    return acc;
}, {});

export const labelMapper: Record<TextMapper, string> = {
    [TextMapper.ORDER]: "Приказ о создании центра",
    [TextMapper.ACTS]: "Локальные нормативные акты",
    [TextMapper.PRICE]: "Прайс-лист",
    [TextMapper.TIMETABLE]: "График работы",
};
